const namespace = 'USER/';

export const CHANGE_PASSWORD = namespace + 'CHANGE_PASSWORD';
export const CREATE_USER = namespace + 'CREATE_USER';
export const GET_BOOKINGS = namespace + 'GET_BOOKINGS';
export const LOGIN = namespace + 'LOGIN';
export const LOGOUT = namespace + 'LOGOUT';
export const REQUEST_PASSWORD_RESET = namespace + 'REQUEST_PASSWORD_RESET';
export const UPDATE_USER = namespace + 'UPDATE_USER';
